import { useState } from 'react';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import { StaticVideo } from '@/types/video.types';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

type TSessionVodEmbedInfoProps = {
  sessionVideo: StaticVideo | null;
  isEditMode?: boolean;
  onReset?: () => void;
  onSave?: (embedCode: string, videoName: string) => void;
};

const SessionVodEmbedInfo = ({ sessionVideo, isEditMode = false, onReset, onSave }: TSessionVodEmbedInfoProps) => {
  const [embedCode, setEmbedCode] = useState(sessionVideo?.type === 'embed' ? sessionVideo?.source : '');

  if (isEditMode) {
    return (
      <Container
        className="flex ai-center gap-12"
        height="84px"
        width="100%"
        background="var(--global-cont-1)"
        padding="12px"
        borderRadius="8px"
      >
        <Container className="flex-column ai-center jc-center gap-4" borderRadius="8px" height="84px" width="100%">
          <Container className="flex ai-center jc-space-between padding-h-8" width="100%">
            <Text className="L2" design="GlobalIcoText3">
              Embed
            </Text>
            <Container className="flex ai-center gap-12">
              <Button padding="0" onClick={onReset}>
                <Text className="S2" color={getThemeColorCSSVariable(EColorVariablesV2.primary)}>
                  Reset
                </Text>
              </Button>
              {/* TODO: implement add thumbnail
              <Text className='L2' color="var(--global-cont-3)">|</Text>
              <Button padding='0' onClick={() => {}}>
                <Text className="S2" color={getThemeColorCSSVariable(EColorVariablesV2.primary)}>
                  Add thumbnail
                </Text>
              </Button> */}
            </Container>
          </Container>
          <InputWithOverlay
            inputHeight="32px"
            wrapperClass="width-100-percent"
            inputProps={{
              placeholder: 'Paste embed code',
              className: 'P2',
              value: embedCode,
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmbedCode(e.target.value),
            }}
            onDebounce={(value) => {
              if (value && onSave) {
                onSave(value, 'Embed');
              }
            }}
            debounceTime={500}
          />
        </Container>
      </Container>
    );
  }

  if (!sessionVideo) return null;

  return (
    <Container className="flex ai-center jc-flex-start" borderRadius="8px" padding="12px" height="84px" width="100%">
      <Container className="flex ai-center jc-center gap-12" height="100%" width="100px">
        {sessionVideo.thumbnail_url && sessionVideo.thumbnail_url.trim() ? (
          <img src={sessionVideo.thumbnail_url} style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '8px' }} />
        ) : (
          <Container
            height="100%"
            width="100%"
            borderRadius="8px"
            border="2px dashed var(--gray-600)"
            design="GlobalCont2"
          />
        )}
      </Container>
      <Container className="flex-column" borderRadius="8px" padding="8px" width="100%">
        <Text className="S3" clamp={2} design="GlobalIcoText1">
          {sessionVideo.source}
        </Text>
        <Text className="C1" design="GlobalIcoText3">
          Embed
        </Text>
      </Container>
    </Container>
  );
};

export default SessionVodEmbedInfo;
